import { Component, Input, OnInit, computed, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CmsComponentData, MediaContainer } from '@spartacus/storefront';

export interface GgTransparentBoxCmsData {
  uid: string;
  image?: MediaContainer;
  title?: string;
  textField1?: string;
}

@Component({
  selector: 'app-gg-transparent-box',
  templateUrl: 'gg-transparent-box.component.html',
  standalone: false,
})
export class GgTransparentBoxComponent implements OnInit {
  private componentData = inject(CmsComponentData<GgTransparentBoxCmsData>);

  @Input() color: string | undefined;
  @Input() compData!: GgTransparentBoxCmsData;

  private cmsDataSignal = toSignal(this.componentData.data$);
  private compDataSignal = signal<GgTransparentBoxCmsData | undefined>(undefined);

  // Computed signal that uses compData if provided, otherwise falls back to CMS data
  dataSignal = computed(() => {
    const compData = this.compDataSignal();
    return compData !== undefined ? compData : this.cmsDataSignal();
  });

  ngOnInit(): void {
    if (this.compData !== undefined) {
      this.compDataSignal.set(this.compData);
    }
  }
}
